import { axiosObject } from "../config";

export default function registerWithMobile(form: any) {
  let payload = {
    type: "mobile_number",
    value: "+91" + form.value.user_identity.toLocaleLowerCase(),
    password: `${Date.now()}`,
  };

  return new Promise((resolve, reject) => {
    let uri = "access/register";

    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        if (errors.response.status === 422) {
          if (
            errors.response.data.errors.value[0] === "Value should be unique"
          ) {
            form.setErrors({ user_identity: ["Mobile already registered"] });
            reject(errors.response.data.errors);
          } else {
            reject(errors.response.data.errors);
          }
        }
        reject(errors);
      });
  });
}
